import { createMuiTheme } from '@material-ui/core';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';

const breakpoints = createBreakpoints({})

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#0089d0',
      action: {
        hover: '#333'
      }
    },
    warning: {
      main: '#fbc02d',
      dark: '#f9a825'
    },
    success: {
      main: '#249e36'
    }
  },
  typography: {
    // In Chinese and Japanese the characters are usually larger,
    // so a smaller fontsize may be appropriate.
    h5: {
      fontSize: '1.25rem'
    },
    h6: {
      fontSize: '1.05rem'
    }
  },
  overrides: {
    // Style sheet name ⚛️

    MuiPaper: {
      root: {
        // borderStyle: 'solid',
        // borderWidth: '1px',
        // boxShadow: 'none',
        // borderColor: '#DDD'
      }
    },

    MuiButton: {
      // Name of the rule

      sizeSmall: {
        padding: '5px 8px',
        fontSize: '13px'
      },
      root: {
        borderRadius: '2px',
        transition: 'all .3s ease-in-out',
        fontWeight: 400
      },
      contained: {
        boxShadow: 'none',
        '&:active': {
          boxShadow: '0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 1px 0px rgba(0,0,0,0.10), 0px 0px 1px 0px rgba(0,0,0,0.12)'
        },
        '&:hover': {
          color: '#fff',
          backgroundColor: '#333'
        }
      },
      containedSecondary: {
        '&:hover': {
          backgroundColor: '#333'
        }
      },
      containedPrimary: {
        '&:hover': {
          backgroundColor: '#333'
        }
      }
    },
    MuiChip: {
      avatar: {
        width: 28,
        height: 28,
        margin: 2
      },
      icon: {
        borderRadius: '100%',
        backgroundColor: 'rgba(0,0,0,0.05)',
        width: '0.9em',
        height: '0.9em'
      },
      deleteIcon: {
        paddingLeft: '4px',
        width: '0.9em',
        height: '0.9em'
      }
    },
    MuiStepIcon: {
      root: {
        color: 'rgb(150,150,150)'
      }
    },
    MuiExpansionPanel: {
      root: {
        '&:before': {
          height: 0
        }
      }
    },
    MuiTab: {
      root: {
        [breakpoints.up('sm')]: {
          minWidth: 'auto'
        }
      }
    }
  }
});

export default theme;
